import { render, staticRenderFns } from "./DashboardActionCenter.vue?vue&type=template&id=4a226908&"
import script from "./DashboardActionCenter.vue?vue&type=script&lang=js&"
export * from "./DashboardActionCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports